import httpClient from '@/libs/http-client'

export function myIp () {
  const url = `/ip_block/my_ip`

  return httpClient.get(url).then(response => {
    return response.data.result
  })
}

export function getIpList (sid) {
  const url = '/ip_block/get_ip_list_by_sid'

  return httpClient.post(url, sid).then(response => {
    return response.data.result
  })
}

export function insertIp (param) {
  const url = `/ip_block/insert_ip`

  return httpClient.post(url, param).then(response => {
    const data = response.data.result
    return data
  })
}

export function removeIp (id) {
  const url = `/ip_block/remove_ip`

  return httpClient.post(url, id).then(response => {
    const data = response.data.result
    return data
  })
}

export function updateIp (param) {
  const url = `/ip_block/update_ip`

  return httpClient.post(url, param).then(response => {
    const data = response.data.result
    return data
  })
}
